import { Box, Button, Divider, Typography } from "@mui/material";
import QuestionField from "./components/QuestionField";
import { useAppDispatch, useAppSelector } from "common/hooks";
import { NODE_TYPES } from "common/constants/enums";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import ConfirmActionPopup from "common/components/ConfirmActionPopup";
import { useState } from "react";
import { onDragEnd } from "common/constants/functions";
import { setNodes, setNodeToAdd, setNodeToEdit } from "store/slices/nodes";
import { Add } from "@mui/icons-material";
import { DisplayIcon } from "common/components/DisplayIcon";
import JsonEditor from "common/components/JsonEditor";
// import FormPreview from "pages/form-preview";

const JsonBuilder = () => {
  const [movingElem, setMovingElem] = useState<any>(null);
  const {
    sectionSummeryGroupId,
    json: { nodes },
    nodeToEdit,
    nodeToAdd,
  } = useAppSelector((state) => state.nodes);
  const dispatch = useAppDispatch();
  const handleCloseActionPopup = () => {
    setMovingElem(null);
  };
  const filteredSSGNodes = nodes?.filter((n: any) => n?.parentNode === sectionSummeryGroupId);
  const handleDragEnd = (result: any) => {
    if (!result) return;
    const { source, destination } = result;
    const isSamePosition =
      !destination || Object.keys(source).every((key) => source[key] === destination[key]);

    if (isSamePosition) return;
    setMovingElem(result);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          right: "450px",
          top: 0,
          borderRadius: 4,
          p: 2,
          zIndex: 1000,
          display: "flex",
          gap: 1,
          background: "#fff",
        }}
      >
        {/* <FormPreview /> */}
        <JsonEditor />
      </Box>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId={String(sectionSummeryGroupId)} type="child">
          {(droppableProvided) => (
            <Box
              {...droppableProvided.droppableProps}
              ref={droppableProvided.innerRef}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {filteredSSGNodes?.map((node: any, index: number) => (
                <Draggable key={node.id} draggableId={node.id} index={index}>
                  {(draggableProvided) => (
                    <Box
                      className={node?.data?.boxLayout === "TRUE" ? "question-group-boxLayout" : ""}
                      sx={{ width: "100%" }}
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      {...draggableProvided.dragHandleProps}
                      style={{
                        ...draggableProvided.draggableProps.style,
                      }}
                    >
                      {node?.data?.boxIcon && <DisplayIcon icon={node?.data?.boxIcon} />}
                      <Typography
                        variant="h5"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(setNodeToEdit(node));
                        }}
                        sx={{
                          textAlign: "center",
                          fontWeight: "600",
                          mb: 5,
                          justifyContent: "space-between",
                          padding: "5px 10px",
                          borderRadius: 1,
                          p: 2,
                          backgroundColor:
                            nodeToEdit?.id === node?.id ? "#1976d215 !important" : "",
                        }}
                      >
                        {node?.data?.properties?.title?.ifValue ||
                          node?.data?.properties?.title?.elseValue}
                      </Typography>
                      <Droppable droppableId={String(node?.id)} type="childNested">
                        {(droppableProvidedLevel2) => (
                          <Box
                            sx={{ p: 2 }}
                            {...droppableProvidedLevel2.droppableProps}
                            ref={droppableProvidedLevel2.innerRef}
                          >
                            {nodes
                              ?.filter((n: any) => n?.parentNode === node?.id)
                              ?.map((n: any, i: number) => (
                                <Draggable key={n.id} draggableId={n.id} index={i}>
                                  {(draggableProvidedLevel2) => (
                                    <Box
                                      key={n?.id}
                                      {...draggableProvidedLevel2.draggableProps}
                                      {...draggableProvidedLevel2.dragHandleProps}
                                      ref={draggableProvidedLevel2.innerRef}
                                      style={{
                                        ...draggableProvidedLevel2.draggableProps.style,
                                      }}
                                    >
                                      {n?.data?.nodeType === NODE_TYPES.question ? (
                                        <QuestionField {...{ node: n }} />
                                      ) : (
                                        <Box
                                          sx={{
                                            border: "1px dashed rgba(0, 0, 0, 0.30)",
                                            p: 2,
                                            borderRadius: 2,
                                          }}
                                        >
                                          <Typography
                                            variant="h5"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              dispatch(setNodeToEdit(n));
                                            }}
                                            sx={{
                                              textAlign: "center",
                                              fontWeight: "600",
                                              mb: 5,
                                              justifyContent: "space-between",
                                              padding: "5px 10px",
                                              borderRadius: 1,
                                              p: 2,
                                              backgroundColor:
                                                nodeToEdit?.id === n?.id
                                                  ? "#1976d215 !important"
                                                  : "",
                                            }}
                                          >
                                            {n?.data?.properties?.title?.ifValue ||
                                              n?.data?.properties?.title?.elseValue}
                                          </Typography>
                                          <Droppable
                                            droppableId={String(n?.id)}
                                            type="childNested2"
                                          >
                                            {(droppableProvidedLevel3) => (
                                              <Box
                                                sx={{ p: 2 }}
                                                {...droppableProvidedLevel3.droppableProps}
                                                ref={droppableProvidedLevel3.innerRef}
                                              >
                                                {nodes
                                                  ?.filter((sub: any) => sub?.parentNode === n?.id)
                                                  ?.map((sub: any, i: number) => (
                                                    <Draggable
                                                      key={sub.id}
                                                      draggableId={sub.id}
                                                      index={i}
                                                    >
                                                      {(draggableProvidedLevel3) => (
                                                        <Box
                                                          key={sub?.id}
                                                          {...draggableProvidedLevel3.draggableProps}
                                                          {...draggableProvidedLevel3.dragHandleProps}
                                                          ref={draggableProvidedLevel3.innerRef}
                                                          style={{
                                                            ...draggableProvidedLevel3
                                                              .draggableProps.style,
                                                          }}
                                                        >
                                                          {" "}
                                                          <QuestionField {...{ node: sub }} />
                                                        </Box>
                                                      )}
                                                    </Draggable>
                                                  ))}

                                                {droppableProvidedLevel3.placeholder}
                                              </Box>
                                            )}
                                          </Droppable>
                                          <Box sx={{ display: "flex", justifyContent: "center" }}>
                                            <Button
                                              variant={
                                                nodeToAdd?.parentNode === n?.id &&
                                                nodeToAdd?.nodeType === NODE_TYPES.question
                                                  ? "contained"
                                                  : "outlined"
                                              }
                                              color="secondary"
                                              size="small"
                                              sx={{ fontSize: 12, filter: "grayscale(1)" }}
                                              onClick={() =>
                                                dispatch(
                                                  setNodeToAdd({
                                                    nodeType: NODE_TYPES.question,
                                                    parentNode: n?.id,
                                                  })
                                                )
                                              }
                                            >
                                              <Add sx={{ mr: 0.5 }} /> Question
                                            </Button>
                                          </Box>
                                        </Box>
                                      )}
                                    </Box>
                                  )}
                                </Draggable>
                              ))}

                            {droppableProvidedLevel2.placeholder}
                          </Box>
                        )}
                      </Droppable>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                        <Button
                          variant={
                            nodeToAdd?.parentNode === node?.id &&
                            nodeToAdd?.nodeType === NODE_TYPES.question
                              ? "contained"
                              : "outlined"
                          }
                          color="secondary"
                          size="small"
                          sx={{ fontSize: 12 }}
                          onClick={() =>
                            dispatch(
                              setNodeToAdd({
                                nodeType: NODE_TYPES.question,
                                parentNode: node?.id,
                              })
                            )
                          }
                        >
                          <Add sx={{ mr: 0.5 }} /> Question
                        </Button>
                        {node?.data?.boxLayout !== "TRUE" && (
                          <Button
                            variant={
                              nodeToAdd?.parentNode === node?.id &&
                              nodeToAdd?.nodeType === NODE_TYPES.subquestiongroup
                                ? "contained"
                                : "outlined"
                            }
                            color="secondary"
                            size="small"
                            sx={{ fontSize: 12 }}
                            onClick={() =>
                              dispatch(
                                setNodeToAdd({
                                  nodeType: NODE_TYPES.subquestiongroup,
                                  parentNode: node?.id,
                                })
                              )
                            }
                          >
                            <Add sx={{ mr: 0.5 }} /> Sub-question Group
                          </Button>
                        )}
                      </Box>
                      {node?.data?.boxLayout !== "TRUE" && <Divider sx={{ my: 3 }} />}
                    </Box>
                  )}
                </Draggable>
              ))}

              {droppableProvided.placeholder}
            </Box>
          )}
        </Droppable>
        {sectionSummeryGroupId && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant={nodeToAdd?.parentNode === sectionSummeryGroupId ? "contained" : "outlined"}
              size="small"
              sx={{ fontSize: 12 }}
              onClick={() =>
                dispatch(
                  setNodeToAdd({
                    nodeType: NODE_TYPES.questionGroup,
                    parentNode: sectionSummeryGroupId,
                  })
                )
              }
            >
              <Add sx={{ mr: 0.5 }} /> Question Group
            </Button>
          </Box>
        )}
        <ConfirmActionPopup
          {...{
            open: !!movingElem,
            onClose: handleCloseActionPopup,
            onConfirm: () =>
              onDragEnd({ movingElem, handleCloseActionPopup, nodes, dispatch, setNodes }),
            text: "move",
          }}
        />
      </DragDropContext>
    </>
  );
};

export default JsonBuilder;
